import { ProductDetailsListItem } from "../components/ProductInfoContent/atoms/ProductDetailsList/ProductDetailsList.types";
import { ProductDetailsData, ProductDetailsVariant } from "../product.types";
import { isLastIndexOfArray } from "./../../../helpers";

export const getProductDetailsInfoList = ({
  product,
  activeProductVariant
}: {
  product: ProductDetailsData;
  activeProductVariant: ProductDetailsVariant;
}): ProductDetailsListItem[] => {
  const productDetailsAttributes = product.attributeValues.reduce(
    (currentProductDetailsList: ProductDetailsListItem[], attributeValue) =>
      attributeValue.attribute.type === "Related"
        ? [
            ...currentProductDetailsList,
            {
              title: attributeValue.attribute.name,
              value: attributeValue.value
            }
          ]
        : currentProductDetailsList,
    []
  );

  const additionalAttributes = product.attributeValues.reduce(
    (acc: ProductDetailsListItem[], attributeValue) =>
      attributeValue.attribute.type === "Additional"
        ? [
            ...acc,
            {
              title: attributeValue.attribute.name,
              value: attributeValue.value
            }
          ]
        : acc,
    []
  );

  const bulkDiscounts = activeProductVariant.quantityDiscounts
    .sort((prev, next) => prev.min - next.min)
    .map((discount, index, discountsArray) => {
      const title = isLastIndexOfArray(index, discountsArray)
        ? `Bulk discount (${discount.min}+)`
        : `Bulk discount (${discount.min} - ${discount.max})`;

      return {
        title,
        value: `${discount.discount ?? 0} %`
      };
    });

  return [
    ...productDetailsAttributes,
    ...additionalAttributes,
    { title: "Weight", value: `${activeProductVariant.weight} kg.` },
    { title: "Volume", value: `${activeProductVariant.volume} cmb.` },
    { title: "Buing Price", value: `${activeProductVariant.buyingPrice} FCFA` },
    {
      title: "Merchant Price",
      value: `${activeProductVariant.merchantPrice} FCFA`
    },
    {
      title: "Recommended Selling Price",
      value: activeProductVariant.recommendedSellingPrice
        ? `${activeProductVariant.recommendedSellingPrice} FCFA`
        : "-"
    },
    ...bulkDiscounts
  ];
};
